import {type IconName} from '@/shared/types/icon';

/* eslint-disable import/no-unresolved */
import {byPrefixAndName as uiIcons, type IconDefinition} from '@awesome.me/kit-4bfc2309f5/icons';
import {byPrefixAndName as resourceIcons} from '@awesome.me/kit-05a70cf04e/icons';
const tagIconsPromise = import('@awesome.me/kit-1af7222dbb/icons');
/* eslint-enable import/no-unresolved */

type IconsByPrefix = Record<string, Record<string, IconDefinition>>;

export type FAIconProps = {name: IconName; solid?: boolean};

/* Canonical icon props per resource type, regardless of how the input is spelled. */
const RESOURCE_TYPE_ICONS: Record<string, FAIconProps> = {
    seat: {name: 'custom-seat' as IconName},
    zone: {name: 'custom-zone' as IconName},
    meetingroom: {name: 'custom-meeting-room' as IconName},
    parkingspace: {name: 'square-parking' as IconName},
};

/* Helper to identify resource type icon props */
export function resourceTypeIconToProps(icon: string): FAIconProps {
    // Normalize inputs like `custom-seat`, `seat`, `fas-seat`, `meeting-room` to a canonical key.
    const canonicalIconKey = icon
        .replace(/^(custom|fa[a-z]?)-/i, '') // drop `custom-` or FA weight prefix (fas, far, fak, ...)
        .replace(/[-_\s]/g, '') // drop separators
        .toLowerCase();

    return RESOURCE_TYPE_ICONS[canonicalIconKey];
}

export async function getIcon(prefix: string, name: string): Promise<IconDefinition | undefined> {
    const {byPrefixAndName: tagIcons} = await tagIconsPromise;
    const iconKits: IconsByPrefix[] = [uiIcons, resourceIcons, tagIcons];

    for (const kit of iconKits) {
        const requestdIcon = kit[prefix]?.[name] || kit['fak']?.[name];
        if (requestdIcon) return requestdIcon;
    }

    // Fallback to 'notdef' icon if requested icon doesn't exist
    return uiIcons[prefix]?.['notdef'] || uiIcons['far']?.['notdef'];
}
